import { Routes } from '@angular/router';
import { VersionListComponent } from './components/version-list/version-list.component';
import { VersionFormComponent } from './components/version-form/version-form.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';

export const CHANGELOG_EDITOR_ROUTES: Routes = [
  { path: '', component: VersionListComponent },
  { path: 'version/new', component: VersionFormComponent },
  { path: 'version/:id', component: VersionFormComponent },
  { path: 'forbidden', component: ForbiddenComponent },
];
